import { Card, CardHeader } from "@mui/material";
import UsersApi from "Classes/API/UsersApi";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useEffect, useState, useContext } from "react";
import ChartComponent from "./ChartComponent";
import Loader from "layouts/loader/loader";
import { LanguageContext } from "App";
const PackagesStatistics = () => {
  const [loading, setLoading] = useState(false);
  const [Page, setPage] = useState(1);
  const [PaginationPages, setPaginationPages] = useState(0);

  const [PackagesStatistics, setPackagesStatistics] = useState({});

  const { translations } = useContext(LanguageContext);
  const [PostPaidAmountArray, setPostPaidAmountArray] = useState([]);
  const [PostPaidAmountUsedArray, setPostPaidAmountUsedArray] = useState([]);
  const [RefundableAmountArray, setRefundableAmountArray] = useState([]);
  const [AmountDueArray, setAmountDueArray] = useState([]);
  const [AmountPaidArray, setAmountPaidArray] = useState([]);
  const [AmountUsedArray, setAmountUsedArray] = useState([]);
  const [DiscountedAmountArray, setDiscountedAmountArray] = useState([]);
  const [DiscountedAmountUsedArray, setDiscountedAmountUsedArray] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const [PostPaididArray, setPostPaidIdArray] = useState([]);
  const [PostPaidUsedidArray, setPostPaidUsedIdArray] = useState([]);
  const [refundableAmountidArray, setRefundableAmountidArray] = useState([]);
  const [topTenAmountDueidArray, setTopTenAmountDueidArray] = useState([]);
  const [topTenAmountPaididArray, setTopTenAmountPaididArray] = useState([]);
  const [topTenAmountUsedidArray, setTopTenAmountUsedidArray] = useState([]);
  const [topTenDiscountedAmountidArray, setTopTenDiscountedAmountidArray] = useState([]);
  const [topTenDiscountedAmountUsedidArray, setTopTenDiscountedAmountUsedidArray] = useState([]);

  const getPackagesStatistics = async () => {
    try {
      UsersApi.GetPackagesStatistics().then((res) => {
        setIsLoaded(true);
        console.log(res.data);
        setPackagesStatistics(res.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching Packages Statistics data:", error);
    }
  };

  useEffect(() => {
    if (PackagesStatistics && PackagesStatistics.topTenPostPaid) {
      const postPaidids = PackagesStatistics.topTenPostPaid.map((item) => item.id);
      const postPaidAmountArray = PackagesStatistics.topTenPostPaid.map((item) =>
        item.postPaidAmount ? item.postPaidAmount : 0
      );

      const postPaidUsedidArray = PackagesStatistics.topTenPostPaidUsed.map((item) => item.id);
      const postPaidUsedAmountArray = PackagesStatistics.topTenPostPaidUsed.map((item) =>
        item.postPaidAmountUsed ? item.postPaidAmountUsed : 0
      );

      const refundableAmountidArray = PackagesStatistics.topTenRefundableAmount.map(
        (item) => item.id
      );
      const refundableAmountArray = PackagesStatistics.topTenRefundableAmount.map((item) =>
        item.refundableAmount ? item.refundableAmount : 0
      );

      const topTenAmountDueidArray = PackagesStatistics.topTenAmountDue.map((item) => item.id);
      const amountDueArray = PackagesStatistics.topTenAmountDue.map((item) =>
        item.amountDue ? item.amountDue : 0
      );

      const topTenAmountPaididArray = PackagesStatistics.topTenAmountPaid.map((item) => item.id);
      const amountPaidArray = PackagesStatistics.topTenAmountPaid.map((item) =>
        item.amountPaid ? item.amountPaid : 0
      );

      const topTenAmountUsedidArray = PackagesStatistics.topTenAmountUsed.map((item) => item.id);
      const amountUsedArray = PackagesStatistics.topTenAmountUsed.map((item) =>
        item.amountUsed ? item.amountUsed : 0
      );

      const topTenDiscountedAmountidArray = PackagesStatistics.topTenDiscountedAmount.map(
        (item) => item.id
      );
      const discountedAmountArray = PackagesStatistics.topTenDiscountedAmount.map((item) =>
        item.discountedAmount ? item.discountedAmount : 0
      );

      const topTenDiscountedAmountUsedidArray = PackagesStatistics.topTenDiscountedAmountUsed.map(
        (item) => item.id
      );
      const discountedAmountUsedArray = PackagesStatistics.topTenDiscountedAmountUsed.map((item) =>
        item.discountedAmountUsed ? item.discountedAmountUsed : 0
      );

      setPostPaidIdArray(postPaidids);
      setPostPaidAmountArray(postPaidAmountArray);

      setPostPaidUsedIdArray(postPaidUsedidArray);
      setPostPaidAmountUsedArray(postPaidUsedAmountArray);

      setRefundableAmountidArray(refundableAmountidArray);
      setRefundableAmountArray(refundableAmountArray);

      setTopTenAmountDueidArray(topTenAmountDueidArray);
      setAmountDueArray(amountDueArray);

      setTopTenAmountPaididArray(topTenAmountPaididArray);
      setAmountPaidArray(amountPaidArray);

      setTopTenAmountUsedidArray(topTenAmountUsedidArray);
      setAmountUsedArray(amountUsedArray);

      setTopTenDiscountedAmountidArray(topTenDiscountedAmountidArray);
      setDiscountedAmountArray(discountedAmountArray);

      setTopTenDiscountedAmountUsedidArray(topTenDiscountedAmountUsedidArray);
      setDiscountedAmountUsedArray(discountedAmountUsedArray);
    }
  }, [PackagesStatistics]);

  const postPaidChartData = {
    labels: PostPaididArray,
    datasets: [
      {
        label: "Post paid amount",
        data: PostPaidAmountArray,
        backgroundColor: [
          "rgba(255, 99, 132, 0.5)",
          "rgba(54, 162, 235, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(75, 192, 192, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 159, 64, 0.5)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const postPaidUsedChartData = {
    labels: PostPaidUsedidArray,
    datasets: [
      {
        label: "Post paid used",
        data: PostPaidAmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const refundableAmountChartData = {
    labels: refundableAmountidArray,
    datasets: [
      {
        label: "Refundable amount",
        data: RefundableAmountArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountDueChartData = {
    labels: topTenAmountDueidArray,
    datasets: [
      {
        label: "Amount due",
        data: AmountDueArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountPaidChartData = {
    labels: topTenAmountPaididArray,
    datasets: [
      {
        label: "Amount paid",
        data: AmountPaidArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountUsedChartData = {
    labels: topTenAmountUsedidArray,
    datasets: [
      {
        label: "Amount used",
        data: AmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const discountedAmountChartData = {
    labels: topTenDiscountedAmountidArray,
    datasets: [
      {
        label: "Discounted amount",
        data: DiscountedAmountArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const discountedAmountUsedChartData = {
    labels: topTenDiscountedAmountUsedidArray,
    datasets: [
      {
        label: "Discounted amount used",
        data: DiscountedAmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    setLoading(true);
    getPackagesStatistics();
  }, []);

  return (
    <DashboardLayout>
      {!isLoaded ? (
        <Loader />
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ff6384" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalPostPaidAmount} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {Number(PackagesStatistics.totalPostPaidAmount).toFixed(2)} EGP
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#ffce56" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalPostPaidUsed} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {Number(PackagesStatistics.totalPostPaidUsed).toFixed(2)} EGP
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#36a2eb" }}>
                  <CardHeader title={translations.StasticsFeedbackTotalPrePaid} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    {Number(PackagesStatistics.totalPrePaid).toFixed(2)} EGP
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div className="container" style={{ display: "flex", flexDirection: "column" }}>
            <div className="row" style={{ display: "flex", flex: 1 }}>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10PostPaid} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={postPaidChartData} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10PostPaidUsed} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={postPaidUsedChartData} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10RefundableAmountPackages} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={refundableAmountChartData} />
                  </MDBox>
                </Card>
              </div>

              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10AmountDue} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={amountDueChartData} />
                  </MDBox>
                </Card>
              </div>

              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10AmountPaid} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={amountPaidChartData} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10AmountUsed} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={amountUsedChartData} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10Discountedamount} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={discountedAmountChartData} />
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
                <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                  <CardHeader title={translations.StasticsFeedbackTop10DiscountedAmountUsed} />
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <ChartComponent chartData={discountedAmountUsedChartData} />
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default PackagesStatistics;
